export default __webpack_public_path__ + "static/media/success_tick.5f4b5aec.svg";